import React from 'react';
import { motion } from 'framer-motion';
import { styled } from '@mui/material/styles';

// Interface for the component props
interface BorderBeamProps {
  size?: number;
  duration?: number;
  delay?: number;
  colorFrom?: string;
  colorTo?: string;
  className?: string;
  style?: React.CSSProperties;
  reverse?: boolean;
  initialOffset?: number;
}

// Styled components
const BorderBeamContainer = styled('div')({
  pointerEvents: 'none',
  position: 'absolute',
  inset: 0,
  borderRadius: 'inherit',
  border: '1px solid transparent',
  maskClip: 'padding-box, border-box',
  maskComposite: 'intersect',
  maskImage: 'linear-gradient(transparent, transparent), linear-gradient(#000, #000)',
});

const BorderBeamElement = styled(motion.div)((props: { colorFrom: string; colorTo: string }) => ({
  position: 'absolute',
  aspectRatio: '1',
  background: `linear-gradient(to left, ${props.colorFrom}, ${props.colorTo}, transparent)`,
}));

// BorderBeam component
export const BorderBeam: React.FC<BorderBeamProps> = ({
  size = 50,
  delay = 0,
  duration = 6,
  colorFrom = "#ffaa40",
  colorTo = "#9c40ff",
  style,
  reverse = false,
  initialOffset = 0,
}) => {
  return (
    <BorderBeamContainer>
      <BorderBeamElement
        colorFrom={colorFrom}
        colorTo={colorTo}
        style={{
          width: size,
          offsetPath: `rect(0 auto auto 0 round ${size}px)`,
          ...style,
        }}
        initial={{ offsetDistance: `${initialOffset}%` }}
        animate={{
          offsetDistance: reverse
            ? [`${100 - initialOffset}%`, `${-initialOffset}%`]
            : [`${initialOffset}%`, `${100 + initialOffset}%`],
        }}
        transition={{
          repeat: Infinity,
          ease: "linear",
          duration,
          delay: -delay,
        }}
      />
    </BorderBeamContainer>
  );
};

export default BorderBeam;